module.exports = __webpack_public_path__ + "img/beer_id-4.a3e03a11.png";